<template>
  <social-sharing
    :url="url"
    :title="title"
    :description="content"
    :quote="quote"
    inline-template
  >
    <div>
      {{ $t("Поделиться в") }}
      <network network="facebook">
        <a href="#" :aria-label="$t('Поделиться в') + ' Facebook'"><i class="pro-icon-facebook1" aria-hidden="true"></i></a>
      </network>
      <network network="twitter">
        <a href="#" :aria-label="$t('Поделиться в') + ' Twitter'"><img src="@/assets/x-icon.png" class="mt-1" height="25" width="25" alt="x icon" aria-hidden="true"></a>
      </network>
      <network network="vk">
        <a href="#" :aria-label="$t('Поделиться в') + ' VK'"><i class="pro-icon-vk" aria-hidden="true"></i></a>
      </network>
    </div>
  </social-sharing>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    quote: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: window.location.href
    }
  }
}
</script>

<style scoped></style>
